import { useQuery } from '@tanstack/react-query'
import { getOpportunityMonthlySales } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseOpportunityMonthlySalesOptions {
  enabled?: boolean
  period?: string
  offset?: number
  limit?: number
}

/**
 * オポチュニティ月次売上一覧を取得するカスタムフック
 *
 * @param opportunityId - オポチュニティID
 * @param options - フックオプション
 * @returns TanStack Query の結果
 */
export function useOpportunityMonthlySales(opportunityId: number, options: UseOpportunityMonthlySalesOptions = {}) {
  const { enabled = true, period, offset, limit } = options

  return useQuery({
    queryKey: queryKeys.opportunity.monthlySales(opportunityId, { period, offset, limit }),
    queryFn: async () => {
      return getOpportunityMonthlySales(opportunityId, { period, offset, limit })
    },
    enabled: enabled && opportunityId > 0,
  })
}
